import React from 'react';
import { Header } from '../../Header/Header';

interface IReportMainComponent {
  src: string;
  id?: string;
  title?: string;
  headerTitle: string;
}

const ReportMainComponent: React.FC<IReportMainComponent> = ({ src, id, title,headerTitle }) => {
  return (
    <div>
      <Header title={headerTitle} type="simple" isDivider={true} />
      <div className="report-wrapper">
        <div style={{ width: '100%', height: '500px', border: '1px solid #ccc' }}>
          <iframe
            id={id}
            src={src}
            title={title}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
              sandbox="allow-scripts allow-same-origin"
          />
        </div>
      </div>
    </div>
  );
};

// Wrap the component with React.memo
export default React.memo(ReportMainComponent);
